import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { GetApi } from "../api/api-service";
import { imgBaseUrl, API_Path } from "../Const";
import developerLogo from "../images/developer.svg";
import AgenciesLoader from "../components/loader/AgenciesLoader";
import NewCommonPagination from "../components/NewCommonPagination";
import noDataFound from "../images/noDataFound.png";
import style from '../style/news.module.css';

export default function DeveloperList() {
    const navigate = useNavigate();
    const [isLoader, setIsLoader] = useState(true);
    const [daveloperData, setDaveloperData] = useState([]);
    const [currentDevPage, setCurrentDevPage] = useState(1);
    const [pageDevSize, setPageDevSize] = useState(20);
    const [totalDevPages, setTotalDevPages] = useState(1);
    const [btnLoader, setBtnLoader] = useState(false);
    const [devValue, setDevValue] = useState("");
    const [serachFlag, setSearchFlag] = useState(true);
    const loaders = Array.from({ length: 8 });

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const parsedFilters = {
            search: params.get("searchValue") || "",
            currentPageA: params.get("page") || 1,
        };
        setDevValue(parsedFilters?.search);
        fetchDevelopers(parsedFilters?.currentPageA, parsedFilters?.search);
    }, []);

    const fetchDevelopers = async (page, searchValue) => {
        let queryString = `pageNumber=${page}&pageSize=${pageDevSize}`;
        if (searchValue) queryString += `&searchValue=${searchValue}`;
        try {
            setIsLoader(true);
            let res = await GetApi(`${API_Path.developerLists}pagination?${queryString}`);
            if (res && res.data.success) {
                setCurrentDevPage(res.data.currentPage);
                setPageDevSize(res.data.pageSize ?? 20);
                setTotalDevPages(res.data.totalPages);
                setDaveloperData(res.data.data);
            } else setDaveloperData([]);
            setIsLoader(false);
            setBtnLoader(false);
        } catch (error) {
            setBtnLoader(false);
            setIsLoader(false);
        }
    };
    const tableDev = (page) => fetchDevelopers(page, devValue);

    const handleSearch = () => {
        setSearchFlag(false);
        navigate(buildSearchUrl());
        setBtnLoader(true);
        fetchDevelopers(1, devValue);
    };
    const handleReset = () => {
        navigate("/dev-list");
        setSearchFlag(true);
        setBtnLoader(true);
        setDevValue("");
        fetchDevelopers(1, "");
    };

    const buildSearchUrl = () => {
        let url = "/dev-list/search/";
        let first = true;
        const add = (key, value) => {
            if (!value || (Array.isArray(value) && value.length === 0)) return;
            url += `${first ? "" : "&"}${key}
            ${encodeURIComponent(Array.isArray(value) ? value.join(",") : value)}`;
            first = false;
        };
        add("/", devValue);
        return url;
    };

    return (
        <div>
            <div className="page-section">
                <div className="page-header dev_header" style={{ padding: "100px 0" }}>
                    <h1>Top Real Estate Developers in UAE</h1>
                    <div className="search_input">
                        <div className="position-relative">
                            <input type="search" placeholder="Search..." className="form-control" value={devValue} onChange={(e) => setDevValue(e.target.value)} />
                            <button
                                type="button"
                                className={`search_btn ${btnLoader ? "opacity" : ""}`}
                                onClick={() => {
                                    serachFlag ? handleSearch() : handleReset();
                                }}
                                disabled={serachFlag && devValue == ""}
                            >
                                {serachFlag ? "Search" : "Reset"}
                                {btnLoader && <span className="spinner-border spinner-border-sm ms-2" aria-hidden="true"></span>}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="agent-profile-sec">
                <div className={style.our_blog_box}>
                    <div className="container">
                        <div className="agent-profile-inner">
                            {isLoader ? (
                                <div className="row">
                                    {loaders.map((_, index) => (
                                        <div className="col-lg-3 col-md-4 col-sm-6" key={index}>
                                            <div className="agent-card-details">
                                                <AgenciesLoader />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : daveloperData && daveloperData.length > 0 ? (
                                <>
                                    <div className="row">
                                        {daveloperData.map((item, i) => (
                                            <div className="col-lg-3 col-md-4 col-sm-6" key={i}>
                                                <div className="agent-card-details">
                                                    <div className="agent-card">
                                                        {/* <Link to={`/new-projects/dev/${item?.slug}`} title={item.name}> */}
                                                        <div className="agencies-card-inner">
                                                            <div className="card_img Dev_card_img">
                                                                <img
                                                                    src={item.path ? imgBaseUrl + item?.path : developerLogo}
                                                                    alt={item.name}
                                                                    loading="lazy"
                                                                    onError={({ currentTarget }) => {
                                                                        currentTarget.onerror = null;
                                                                        currentTarget.src = `${developerLogo}`;
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="agent_card_content">
                                                                <h2 className="agent-name">{item.name}</h2>
                                                                <div className="dev_descs">
                                                                    <p>{item?.shortDescription}</p>
                                                                </div>
                                                                <div className="pjt_count">
                                                                    <Link to={`/new-project/dev=${item?.name}`}>
                                                                        <div className="pjt-actions-btn">
                                                                            <button>See Project</button>
                                                                            {/* <Link to={`/new-projects/dev/${item?.slug}`}><button>See {item?.pjtTal} Project</button></Link> */}
                                                                        </div>
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* </Link> */}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <NewCommonPagination currentPage={currentDevPage} pageSize={pageDevSize} totalPages={totalDevPages} tableCallBack={tableDev} data={buildSearchUrl()} />
                                </>
                            ) : (
                                <div className="content_notfound">
                                    <img src={noDataFound} alt="No results matching your search" />
                                    <h3>No results matching your search.</h3>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
